import { render, staticRenderFns } from "./TerminalSettingsView.vue?vue&type=template&id=356c8183&"
import script from "./TerminalSettingsView.vue?vue&type=script&lang=js&"
export * from "./TerminalSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./TerminalSettingsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports